import "./src/styles/global.css"
import DefaultLayout from "./src/layouts/wrapPageElement";

export const wrapPageElement = DefaultLayout;
